import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propArrayNum, propArrayShape, propBool, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
import ClientSeminarItems from '../../../Seminar/List/Items/ClientSeminarItems';
const ConsultantSeminar = (props) => {
    const { isClient, isNoResult, isProfessional, isShow, onClickDocumentLink, onClickDocumentLinkByGuest, onClickSearchResult, seminarPage: { initialLoaded, list, loading }, seminarThemes, viewSeminarThemes, } = props;
    /**
     * ユーザーの種類
     * @type {string} 'guest' | 'client' | 'professional'
     */
    const userType = useMemo(() => {
        let type = 'guest';
        if (isClient) {
            type = 'client';
        }
        else if (isProfessional) {
            type = 'professional';
        }
        return type;
    }, [isClient, isProfessional]);
    /**
     * タグに表示する theme
     */
    const filteringTheme = useMemo(() => {
        var _a, _b;
        // 表示してあるテーマの順に並べる
        const filteringThemes = viewSeminarThemes.filter(({ id }) => seminarThemes.includes(id));
        return (_b = (_a = filteringThemes[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }, [seminarThemes, viewSeminarThemes]);
    return (_jsx("div", Object.assign({ className: clsx('search_list_block_all', 'client_seminar', (!isShow || isNoResult) && 'is-dnone') }, { children: _jsx(ClientSeminarItems, { className: 'is-noMargin', filteringTheme: filteringTheme, isPreview: false, loading: !initialLoaded || loading, onClickDocumentLink: userType === 'guest'
                ? onClickDocumentLinkByGuest
                : onClickDocumentLink, onClickMore: () => { }, onClickSearchResult: onClickSearchResult, seminars: list || [], showMore: false, userType: userType }) })));
};
ConsultantSeminar.propTypes = {
    isClient: propBool().isRequired,
    isNoResult: propBool().isRequired,
    isProfessional: propBool().isRequired,
    isShow: propBool().isRequired,
    onClickDocumentLink: propFunc().isRequired,
    onClickDocumentLinkByGuest: propFunc().isRequired,
    onClickSearchResult: propFunc().isRequired,
    seminarPage: propShape().isRequired,
    seminarThemes: propArrayNum().isRequired,
    viewSeminarThemes: propArrayShape().isRequired,
};
export default ConsultantSeminar;
